const appRescueDiagnosticEmail = "info@shockvaluemedia.com";

export type AppRescueDiagnosticCtaMode = "scheduler" | "email";

export interface AppRescueDiagnosticCta {
  href: string;
  label: string;
  mode: AppRescueDiagnosticCtaMode;
  opensNewTab: boolean;
}

export function buildAppRescueDiagnosticCta(
  referenceId?: string,
  schedulerUrl?: string
): AppRescueDiagnosticCta {
  const href = buildAppRescueSchedulerUrl(schedulerUrl, referenceId);

  if (href) {
    return {
      href,
      label: "Book diagnostic",
      mode: "scheduler",
      opensNewTab: true,
    };
  }

  return {
    href: buildAppRescueDiagnosticMailto(referenceId),
    label: "Send booking email",
    mode: "email",
    opensNewTab: false,
  };
}

export function buildAppRescueDiagnosticMailto(referenceId?: string): string {
  const subject = "App Rescue diagnostic request";
  const body = [
    "Hi SVM,",
    "",
    "I submitted an App Rescue request and want to book the diagnostic review.",
    referenceId ? `Reference: ${referenceId}` : "",
    "",
    "Good windows for a 25-minute call:",
    "1.",
    "2.",
    "",
    "I can share a safe preview link, walkthrough, or read-only access after you reply.",
  ].filter((line, index, lines) => line || lines[index - 1] !== "").join("\n");

  return `mailto:${appRescueDiagnosticEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function buildAppRescueSchedulerUrl(schedulerUrl?: string, referenceId?: string): string {
  if (!schedulerUrl?.trim()) return "";

  try {
    const url = new URL(schedulerUrl.trim());
    url.searchParams.set("source", "shockvaluemedia.com");
    url.searchParams.set("service", "app_rescue");
    url.searchParams.set("conversion_goal", "diagnostic_booked");

    if (referenceId?.trim()) {
      url.searchParams.set("reference_id", referenceId.trim());
    }

    return url.toString();
  } catch {
    return "";
  }
}
